export default __webpack_public_path__ + "static/media/bice_pool.56208ef2.png";